import {
  Typography,
  CardContent,
  TextField,
  Button,
  InputAdornment,
} from "@mui/material";
import { React, useState, useEffect } from "react";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import Box from "@mui/material/Box";
import R from "../../images/R.png";
import "../blockpay.css";
import RadioButtons from "./radio";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Img from "../../images/withdraw_pic1.png";
import SelectLabels from "./formSelect";
import WithdrawModal from "./Modals/withdrawModal";
import axios from "axios";
import { setAuthToken } from "../../utils/setAuthToken";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import { Link, useNavigate } from "react-router-dom";
import CancelIcon from "@mui/icons-material/Cancel";

export default function WithdrawForm2() {
  const navigate = useNavigate();
  // Modal use State
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    navigate("/dashboard", { replace: true });
  };
  //  Component States
  const [value, setValue] = useState("");
  const [zar, setZar] = useState("");
  const [network, setNetwork] = useState("");
  // balance use states
  const [bal, setBal] = useState("");

  // Backdrop usestates and functions
  const [openbackdrop, setOpenbackdrop] = useState(false);
  const handleClosebd = () => {
    setOpenbackdrop(false);
  };
  const handleOpenbd = () => {
    setOpenbackdrop(true);
  };

  //Calling APIs

  const handleSubmit = (e) => {
    e.preventDefault();
    setOpenbackdrop(true);
    axios
      .post("https://api.blockpay.co.za/blockchain/withdraw", {
        senderaddress: network,
        amount: value,
        network: "Ethereum",
        token: "ETH",
      })
      .then((res) => {
        handleClosebd();
        toast.success(res.data.message);
        console.log(res.data);
        handleOpen();
      })
      .catch((err) => {
        toast.error(err.response.data.message);
        setTimeout(() => {
          handleClosebd();
        }, 2000);
        console.log(err);
        if (err.response.data.message == "Unauthorized!") {
          axios
            .post("https://api.blockpay.co.za/auth/refreshToken", {
              refreshToken: localStorage.getItem("refreshToken"),
            })
            .then((res) => {
              console.log(res);
              localStorage.setItem("jwtToken", res.data.accessToken);
              setTimeout(() => {
                window.location.reload();
              }, 500);
            })
            .catch((err) => {
              console.log(err);
              localStorage.clear();
              window.location.reload();
            });
        }
      });
  };

  const getBal = (e) => {
    // e.preventDefault();
    setAuthToken(localStorage.getItem("jwtToken"));
    axios
      .get("https://api.blockpay.co.za/blockchain/allBalances", {})
      .then((res) => {
        console.log(res);
        setBal(res.data.balance[0].balance);
      })
      .catch((err) => {
        console.log(err);
        if (err.response.data.message == "Unauthorized!") {
          axios
            .post("https://api.blockpay.co.za/auth/refreshToken", {
              refreshToken: localStorage.getItem("refreshToken"),
            })
            .then((res) => {
              console.log(res);
              localStorage.setItem("jwtToken", res.data.accessToken);
              setTimeout(() => {
                window.location.reload();
              }, 500);
            })
            .catch((err) => {
              console.log(err);
              localStorage.clear();
              window.location.reload();
            });
        }
      });
  };
  const balance = bal;
  const handleChange = (event) => {
    event.preventDefault();
    const enteredValue = event.target.value;
    // console.log(enteredValue);
    const x = enteredValue;
    setValue(enteredValue);
    axios
      .get(
        "https://api.coingecko.com/api/v3/simple/price?ids=ethereum&vs_currencies=zar"
      )
      .then((res) => {
        console.log(res.data.ethereum.zar);
        console.log(res.data.ethereum.zar * parseFloat(x));
        setZar((res.data.ethereum.zar * parseFloat(x)).toFixed(2));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const showError =
    parseFloat(value) > balance ||
    parseFloat(value) <= 0 ||
    !parseFloat(value);
  useEffect(() => {
    getBal();
  }, []);
  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={openbackdrop}
        onClick={handleClosebd}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <ToastContainer />
      <Box
        className="loginCard"
        sx={{
          paddingTop: "7px!important",
          width: "100%!important",
          boxShadow: "0px 10px 20px 5px rgba(0, 0, 0, 0.08)",
          border: "none!important",
          "@media (max-width:1200px)": { mt: "2rem" },
        }}
      >
        <CardContent>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Box
              sx={{
                color: "#919191",
                textAlign: "left",
              }}
            >
              <SelectLabels />
            </Box>
            <Box
              sx={{
                color: "#919191",
                textAlign: "right",
              }}
              component={Link}
              to="/dashboard"
            >
              <CancelIcon />
            </Box>
          </Box>
          <Box
            component="img"
            src={Img}
            sx={{ height: "auto", width: "10rem", mb: "1rem" }}
          />
          <form onSubmit={handleSubmit}>
            <TextField
              variant="standard"
              InputProps={{
                disableUnderline: true,
                endAdornment: <InputAdornment position="end"></InputAdornment>,
              }}
              placeholder="Withdraw to Ethereum Address"
              sx={{
                background: "#EFEFEF",
                padding: "1rem 1rem",
                borderRadius: "10px",
                marginBottom: "1.375rem",
                input: {
                  "&::placeholder": {
                    color: "black",
                    fontWeight: "500",
                  },
                },
              }}
              onChange={(e) => setNetwork(e.target.value)}
              required
            />
            <TextField
              variant="standard"
              type="number"
              error={showError}
              onChange={handleChange}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Typography
                      sx={{
                        color: showError ? "red" : "inherit",
                        fontWeight: "500",
                      }}
                    >
                      ETH
                    </Typography>
                  </InputAdornment>
                ),
                style: {
                  color: showError ? "red" : "inherit",
                },
              }}
              inputProps={{ step: 0.0001 }}
              // defaultValue="0.00"
              placeholder="0.00"
              sx={{
                marginBottom: "3px",
                input: {
                  "&::placeholder": {
                    color: "black",
                    fontWeight: "500",
                  },
                },
              }}
            />
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "2rem",
              }}
            >
              <Typography sx={{ fontWeight: "500" }}>
                {zar ? zar : "0.00"}
              </Typography>
              <Typography sx={{ fontWeight: "500" }}>RANDS</Typography>
            </Box>

            <Button
              className="loginButtonSignUp"
              variant="contained"
              color="primary"
              size="large"
              type="submit"
              disabled={showError}
              sx={{ width: "100%", borderRadius: "13px" }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box className="buttonSignText">Withdraw</Box>
              </Box>
            </Button>
            <WithdrawModal open={open} onClose={handleClose} />
          </form>
        </CardContent>
      </Box>
    </>
  );
}
